import React from "react";
import PropTypes from "prop-types";
import Modal from "react-modal";
import "../styles/PreviewItem.css"; // Optional: Add specific styles for PreviewItem

const PreviewItem = ({ file, isOpen, onClose }) => {
  if (!file) return null;
  // Determine the file type based on the file extension
  const getFileType = (fileName) => {
    const extension = fileName.split(".").pop().toLowerCase();
    if (["jpeg", "jpg", "png"].includes(extension)) return "image";
    if (extension === "pdf") return "pdf";
    return "unsupported";
  };
  const fileType = getFileType(file.name);

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onClose}
      className="preview-modal"
      overlayClassName="preview-overlay"
      ariaHideApp={false} // Allow for easier testing in development
    >
      <div className="preview-container">
        <h3>Previewing: {file.name}</h3>
        <div className="preview-content">
          {fileType === "image" && (
            <img
              src={file.sasUrl}
              alt={file.name}
              className="preview-image"
            />
          )}
          {fileType === "pdf" && (
            <embed
            src={file.sasUrl}
            type="application/pdf"
            className="preview-embed"
          />
          )}
          {fileType === "unsupported" && (
            <p>
              This file type is not supported for preview. You can download it
              to view.
            </p>
          )}
        </div>
        <button onClick={onClose} className="close-button">
          Close
        </button>
      </div>
    </Modal>
  );
};

PreviewItem.propTypes = {
    file: PropTypes.shape({
      name: PropTypes.string.isRequired,
      sasUrl: PropTypes.string.isRequired,
    }),
    isOpen: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
  };

export default PreviewItem;